<template>
    <div class="templete_box">
        <div class="crumbsNav clearfix no_print">
            <div class="navSon navSonChecked">
                板材销售
            </div>
            <div class="navSon" >
                原木销售
            </div>
        </div>
        <div class="templete no_print">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.search.order_sn" placeholder="销售单号"></el-input>
                <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
                <el-select class="search_select search_inputBox" v-model="params.search.salesman_id" placeholder="销售人" @visible-change="getSelectList('user')">
                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <!-- <div class="sousuoBtn" @click="openSou"></div> -->
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <!-- <div class="btnList clearfix">
                <el-button class="funcPublicBtn" v-if="module.includes(',sell-order-edit,')" @click="dialogVisible=true;orderType=1;detailInfo={}">新建销售单</el-button>
                <el-button class="funcPublicBtn" v-if="module.includes(',sell-order-edit,')" @click="batchDel">批量删除</el-button>
                <el-button class="funcPublicBtn" v-if="module.includes(',sell-order-edit,')" @click="batchBack">批量撤回</el-button>
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.includes(',sell-order-edit,') && !module.includes(',sell-order-disable-submit,')" @click="batchExamine">提交销售审核</el-button>
            </div> -->
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="order.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow"  @backClick="backClick" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal">
                <!-- <div class="totalNumber">选中立方： {{total_select}}</div> -->
                <div class="totalNumber">合计件数： {{totalObj.count}}</div>
                <div class="totalNumber">合计立方： {{totalObj.total_cube}}</div>
                <div class="totalNumber">合计金额： {{totalObj.total_amount}}</div>
                <div class="totalNumber"></div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import tabletem from '../../components/table.vue';
    import pagination from '../../components/pagination.vue';
    import selectDownCustomer from '../../components/selectDownCustomer.vue';
    import saleBillBase from '../../components/saleBillBase.vue';
    import saleCheckout from './saleCheckout.vue';
    const initBusinessRelationForm = {
        order_id: "",
        order_sn: "",
        fee_date: "",
        fee_id: "",
        fee_name: "",
        payee: "",
        amount: "",
        is_invoice: "",
        remark: ""
    };
    const initSearchParams = {
        search: {
            order_sn: "",
            sales_time: "",
            start_time: "",
            end_time: "",
            customer_id: "",
            salesman_id: "",
            status: "",
            customer_name:"",
            truck_remark:""
        },
        page: 1,
        per_page: 50
    };
    const initTotalObj = {
        total_amount: "",
        total_cube: "",
        total_select: 0,
        count: 0
    };
    export default {
        data() {
            return {
                detailInfo: {},
                totalObj: this.$cloneJson(initTotalObj),
                is_current_time: true,//是否使用当前时间 （0否 1是）
                isShowDiffDateCheckBox: true,//是否显示checkbox
                submitConfirmDialog: false,//对话框
                transferOrderDialog: false,//删除时，调货数据提示框
                submitConfirmType: '',//确认提交类型
                batchSubIds: [],
                transferId:'',//删除有调货数据的id
                tran_action:true,
                tableLoading: false,
                module: localStorage.dw_erp_power_code,

                boardAmericaType: localStorage.dw_erp_board.includes("board-america"),
                boardAfricaType: localStorage.dw_erp_board.includes("board-africa"),
                categoryRawType: localStorage.dw_erp_category.includes("raw"),
                categoryBoardType: localStorage.dw_erp_category.includes("board"),

                filter: [],
                printCustomer: "",
                printSale: "",
                companyName: localStorage.dw_erp_company_name,
                businessRelation: false,
                outFeeSelect: [],
                businessRelationForm: this.$cloneJson(initBusinessRelationForm),
                feeOutFormRlues: {
                    fee_date: [{required: true, message: '请填写日期', trigger: 'blur'}],
                    order_id: [{required: true, message: '请选择销售单号', trigger: 'blur'}],
                    fee_id: [{required: true, message: '请选择费用名称', trigger: 'blur'}],
                    payee: [{required: true, message: '请填写收款人', trigger: 'blur'}],
                    amount: [{required: true, message: '请填写金额', trigger: 'blur'}],
                    is_invoice: [{required: true, message: '请选择是否开票', trigger: 'blur'}],
                },
                newFee: [],
                print_tpl_id:0,
                start_time: "",
                end_time: new Date(),
                sales_time: new Date(),
                delivery_time: new Date(),
                predict_time: new Date(),
                params: this.$cloneJson(initSearchParams),
                listType: "",

                dialogVisible: false,//
                checkoutDialogVisible: false,//部分等待出库销售单据
                filterDialogVisible:false,
                filter:"",
                fields:"",
                centerDialogVisible: false,
                dialogVisibleCustomer: false,
                relationObj: {},
                refuse_remark: "",
                last_page: 1,
                total: 0,
                selectRow: [],
                customerList: [],
                customerListT: [],
                saleManList: [],
                paymenttypeList: [],
                accountList: [],
                selectMap: {
                    user: [],
                    options:[],
                    saleTemplate:[]
                },
                list: [],
                tableCol: [
                    {colName:"销售日期",colKey:"sales_time",isDate:true,colWidth:90,isCanClick:false,backClick:false},
                    {colName:"销售单号",colKey:"order_sn",colWidth:190,isCanClick:true,backClick:false},
                    {colName:"订单状态",colKey:"status_text",colWidth:100,isCanClick:false,backClick:true,isColor:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:170,isCanClick:false,backClick:false},
                    {colName:"件数",colKey:"count",colWidth:50,isCanClick:false,backClick:false},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:80,isCanClick:false,backClick:false},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:100,isCanClick:false,backClick:false},
                    {colName:"销售人",colKey:"salesman_name",colWidth:80,isCanClick:false,backClick:false},
                    {colName:"审核人",colKey:"auditor_name",colWidth:80,isCanClick:false,backClick:false},
                    {colName:"制单人",colKey:"creator_name",colWidth:80,isCanClick:false,backClick:false},
                    {colName:"收结状态",colKey:"already_amount",colWidth:100,isCanClick:false,isColor:true,},
                    {colName:"备注",colKey:"remark",colWidth:150,isCanClick:false,backClick:false},
                    {colName:"订单来源",colKey:"order_source_text",colWidth:75,isCanClick:false,backClick:false},
                    {colName:"锁定等级",colKey:"lock_level",colWidth:100,isCanClick:false,isColor:true,islockLevel:true},
                    {colName:"提货车牌",colKey:"truck_remark",colWidth:100,isCanClick:false},
                    ],

                total_select: 0,
                orderType: 1,//1新增 2修改 3详情
                orderId:0,
                refreshSale:{},//刷新销售单弹框
                addId:0,
                customerDialogVisibles:false,

            };
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
            this.getSelectList("saleTemplate");
        },
        methods:{
            
            exportExcelBill(){
                this.$exportExecl("/erp/order.export","销售单",{id:this.detailInfo.id,"scene":"order.create.column"})
            },

            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            print(category){
                let url = "/saleOrderPrint?id=" + this.detailInfo.id + "&category=" + category;
                window.open(url);
            },
           

        
            //保存，修改
            save(type, skipCheck = false) {
                let $baseRef = this.$refs.saleBillBase;
                $baseRef.$refs["saleorderA"].validate((valid) => {
                    if (valid) {
                        $baseRef.$refs["saleorderB"].validate((validC) => {
                            let tran_action = this.$cloneJson($baseRef.tran_action);
                            let _params = this.$cloneJson($baseRef.form_params);
                            let _listDetail = this.$cloneJson($baseRef.listDetail);
                            if(_params.rec_type==2){
                                _params.rec_type = 'DIV'
                            }else{
                                _params.rec_type = 'MUL'
                            }
                            if (validC) {
                                let url = "";
                                if (this.orderType === 1) {
                                    url = "/erp/order.create";
                                    _params.fee_list = this.newFee;
                                    _params.print_tpl_id = this.print_tpl_id;
                                } else {
                                    _params.print_tpl_id = this.print_tpl_id;
                                    url = "/erp/order.update";
                                }
                                _params.tran_action = tran_action ? 1 : 0;
                                _params.rec = _params.rec ? 1 : 0;
                                _params.is_show_traffic = _params.is_show_traffic ? 1 : 0;
                                _params.is_discount_rate = _params.is_discount_rate ? 0 : 0;
                                _params = this.$changeTimeParams(_params, ['sales_time', 'predict_time', 'delivery_time']);
                                let inventory_list = [];
                                let cloud_list = [];
                                _listDetail.forEach(item => {
                                    if (item.inventory_cloud_id) {
                                        cloud_list.push(item)
                                    } else {
                                        inventory_list.push(item)
                                    }
                                });
                                _params.inventory_list = inventory_list;
                                _params.cloud_list = cloud_list;
                                _params.is_request_review = type;
                                if (Number(type) === 1) {
                                    if (skipCheck) {
                                        //跳过检查
                                        _params.is_current_time = Number(this.is_current_time);
                                    }else {
                                        //提交审核时才提示弹框，仅保存时不提示
                                        let hasBeforeDays = this.$isHasBeforeDays([_params], 'sales_time');
                                        if (hasBeforeDays) {
                                            this.submitConfirmType = 'dialogSubmit';
                                            this.isShowDiffDateCheckBox = true;
                                            this.is_current_time = true;//默认勾选
                                            this.submitConfirmDialog = true;
                                            return;
                                        }
                                    }
                                }
                                this.postFuncLoading(url, _params, () => {
                                    this.submitConfirmDialog = false;
                                    this.dialogVisible = false;
                                    this.tip('操作成功', 'success');
                                    this.getList();
                                }, error => {
                                    this.tip(error.data.message, "warning")
                                })
                            } else {
                                return false;
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            checkout(){
                let $baseRef = this.$refs.saleCheckout;
                let _params = this.$cloneJson($baseRef.form_params);
                let _listDetail = this.$cloneJson($baseRef.listDetail);
                // let arrnew = _listDetail.map((item,index) => {
                //     return Object.assign({},{'id':item.id,"inventory_id":item.inventory_id,'sales_width':item.sales_width,"sales_cube":item.sales_cube,"sales_price":item.sales_price,"status":item.status})
                // })
                this.postFuncLoading('/erp/order.modify',{id:_params.id,inventory_list:_listDetail},res=>{
                    this.checkoutDialogVisible=false;
                    this.tip('操作成功', 'success');
                    this.getList();
                })
            },
            getRow(row){
                this.selectRow=row;
            },
            reset(){
                this.start_time="";
                this.end_time = new Date();
                this.$refs['selectdowncustomer'].clearData();
                this.params = this.$cloneJson(initSearchParams);
                this.getList();
            },
            filterConfirm(){
                this.getList()
            },
          
            getList(flag){
                if(flag)this.params.page = 1;
                let searchKey=this.$cloneJson(this.params);
                searchKey.search.start_time = this.formatTimeZero(this.start_time);
                searchKey.search.end_time = this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/order.list",searchKey,res=>{
                    this.filter = res.data.data.column;
                    let resD = res.data.data;
                    this.last_page=parseInt(resD.last_page);
                    this.params.page=parseInt(resD.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(resD.total);
                    this.totalObj=this.$cloneJson(resD.statistics);
                    this.list=this.$cloneJson(resD.list);
                    this.list.forEach((item,index)=>{
                        item.baseColor = "";
                        if(item.status==2){
                            item.baseColor="#B400FF";
                        }else if(item.status==3){
                            item.baseColor="#155BD4";
                        }else if(item.status==4){
                            item.baseColor="#B400FF";
                        }else if(item.status==5){
                            item.baseColor="#007B04";
                        }else if(item.status==6){
                            item.baseColor="#007B04";
                        }else if(item.status==1){
                            item.baseColor="#FF0000";
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            backClick(id){
                this.list.forEach(item=>{
                    if(id==item.id){
                        this.centerDialogVisible=true;
                        this.refuse_remark=item.refuse_remark;
                    }
                })
            },
            rowClick(obj){
                let total_number = 0;
                this.orderId =obj.id;
                this.refreshSale = obj;
                this.postFuncLoading("/erp/order.order", {id: obj.id}, res => {
                    let resD = res.data.data;
                    this.orderType = resD.isEdit ? 2 : 3;
                    res.data.data.relate_list.forEach(item =>{
                        if(item.rec == 1){
                            total_number += Number(item.amount);
                        }
                    })
                    resD.tax_rec_amount = total_number;
                    if(resD.rec_type=='DIV'){
                        resD.rec_type = 2
                    }else{
                        resD.rec_type = 1
                    }
                    this.newFee = resD.fee_list;
                    this.detailInfo = resD;
                    this.detailInfo.saleOrderIsEdit = !!resD.isEdit;
                    this.detailInfo.saleOrderIsCancel = !!resD.isCancel;
                    this.detailInfo.saleOrderIsSuperEdit = !!resD.isSuperEdit;
                    this.print_tpl_id = res.data.data.print_tpl_id;
                    this.dialogVisible = true;
                }, error => {
                    this.tip(error.data.message, "warning")
                });
            },
           
            getTableDelete(id,row){
                this.del([id],row);
            },
            getTableSee(id){
                this.pl(id);
            },
            getTableEdit(id){
                this.rowClick({
                    id: id,
                    name: 'id',
                    // row: row
                });
            },
        },
        components:{
            tabletem,
            pagination,
            selectDownCustomer,
            saleBillBase,
            saleCheckout
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },


            "businessRelation":function(val){
                if(!val){
                    this.businessRelationForm = this.$cloneJson(initBusinessRelationForm);
                }else{
                    if(this.$refs['feeOutForm']){
                        this.$refs['feeOutForm'].clearValidate()
                    }
                }
            },
            "centerDialogVisible":function(val){
                if(!val){
                    this.refuse_remark="";
                }
            },
            dialogVisible:function (val) {
                if (!val) {
                    this.detailInfo = {};
                    this.newFee = [];
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    .REC_FORM_ITEM /deep/ .el-form-item__content{
        position: relative;
    }
    .taxDiv /deep/ {
        .taxCheck{
            z-index: 11;
        }
        .taxTypeSelect{
            width: 40px;
            position: absolute;
            left: 20px;
            top: 1px;
            z-index: 9;
            .el-input__inner{
                padding-right: 0;
                padding-left: 5px;
                font-size: 14px;
                border-right: none;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
            .el-select__caret{
                font-size: 10px;
                position: relative;
                left: 10px;
            }
        }
        .taxInput{
            position: absolute;
            top: 0;
            padding-left: 60px;
            .el-input__inner{
                padding-left: 10px;
                padding-right: 15px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
        .taxSpan{
            position: absolute;
            right: 3px;
            top: 1px;
            color: red;
        }
    }

    .confirmCheckBox /deep/ .el-checkbox__input{
        position: relative;
        top: -10px;
    }
    .confirmCheckBox /deep/ .el-checkbox__label{
        display: inline-block;
        width: 320px;
        white-space: pre-wrap;
        text-align: left;
    }
    .transferConfirmCheckBox /deep/ .el-checkbox__input{
        position: relative;
        // top: -10px;
    }
    .transferConfirmCheckBox /deep/ .el-checkbox__label{
        display: inline-block;
        width: 320px;
        white-space: pre-wrap;
        text-align: left;
    }
    .cDiaC /deep/ .confirmSpan{
        text-align: left;
        display: block;
    }
    .cDiaC /deep/ .el-dialog__body{
        padding: 20px;
    }
    .cDiaC /deep/ .dialogBtnList{
        padding: 20px 10px 0 10px;
    }
    .cDiaC /deep/ .dialogBtnList .funcPublicBtn,.cDiaC /deep/ .dialogBtnList .publicBtn{
        line-height: 25px;
        padding: 0 10px;
        width: 80px;
    }
    .cDiaC /deep/ .el-dialog__header{
        text-align: left;
    }
    .cDiaC /deep/ .el-dialog__header .el-dialog__title{
        font-size: 15px;
        font-weight: unset;
    }
    .el-icon-more{position: absolute;right:0;cursor: pointer;top:2px;}

    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .bottom_flex{padding-right: 12px; padding-bottom: 8px;}
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
</style>
